export const iconFontAwesomeSocialThumbtack = (
	<i className="fa-solid fa-thumbtack"></i>
);
